export default __webpack_public_path__ + "static/media/DINNextCYR-Regular.4b72a7e2.woff";